import { Map } from 'immutable';

import { actionTypes } from './actions';
import initialState from './initialState';

export default function objectReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_DATA:
      return Map(action.payload);
    case actionTypes.RESET:
      return initialState;
    default:
      return state;
  }
}
